import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseInquiryScrollSliderEnum } from '../_enums/base-inquiry-scrolling-meta-data.enum';

@Injectable()
export class BaseInquiryScrollService {
  private scrollOffsetSubject = new BehaviorSubject<number>(0);
  scrollOffset$ = this.scrollOffsetSubject.asObservable();
  private visibleDatesQtySubject = new BehaviorSubject<number>(0);
  visibleDatesQty$ = this.visibleDatesQtySubject.asObservable();
  private isScrollOnStart = new BehaviorSubject<boolean>(true);
  isScrollOnStart$ = this.isScrollOnStart.asObservable();

  scrollLeftToWeekStart(scrollOffset: number): void {
    this.setScrollOffset(scrollOffset ? scrollOffset - (scrollOffset % 7 || 7) : 0);
    this.isScrollOnStart.next(scrollOffset <= 7);
  }

  scrollRightToNextWeek(scrollOffset: number, datesLength: number) {
    this.scrollOffsetSubject.next(
      scrollOffset < datesLength - this.visibleDatesQtySubject.value
        ? scrollOffset + (7 - (scrollOffset % 7))
        : datesLength - this.visibleDatesQtySubject.value
    );
    this.isScrollOnStart.next(false);
  }

  setSliderOffsetValue(value: BaseInquiryScrollSliderEnum | number, datesLength?: number) {
    switch (value) {
      case BaseInquiryScrollSliderEnum.start:
        this.scrollToStart();
        break;
      case BaseInquiryScrollSliderEnum.end:
        if (datesLength) {
          this.scrollToEnd(this.visibleDatesQtySubject.value, datesLength);
        }
        break;
      case BaseInquiryScrollSliderEnum.left:
        this.scrollLeftToWeekStart(this.scrollOffsetSubject.value);
        break;
      case BaseInquiryScrollSliderEnum.right:
        if (datesLength) {
          this.scrollRightToNextWeek(this.scrollOffsetSubject.value, datesLength);
        }
        break;
      default:
        this.setScrollOffset(value);
        this.isScrollOnStart.next(value === 0);
    }
  }

  setVisibleDatesValue(value: number) {
    this.visibleDatesQtySubject.next(value);
  }

  private setScrollOffset(offset: number): void {
    this.scrollOffsetSubject.next(offset);
  }

  private scrollToStart() {
    this.scrollOffsetSubject.next(0);
    this.isScrollOnStart.next(true);
  }

  private scrollToEnd(scrollOffset: number, datesLength: number) {
    this.scrollOffsetSubject.next(datesLength - scrollOffset);
    this.isScrollOnStart.next(false);
  }
}
